/**
 * What the Ask Sigora drawer says in its own voice, apart from the conversation itself. One module,
 * so the product copy is one file to change.
 */

/**
 * Above the composer while a turn runs on another step, with Send held until it ends. It names no
 * step: the turn is most often one the researcher did not start, and the reply lands in the thread
 * it was asked in.
 */
export const BUSY_ELSEWHERE_NOTICE =
  "Sigora is finishing another reply. You can send once it's done.";

/** What Sigora says first on a thread nobody has said anything in, on every step. */
export const CHAT_GREETING = 'Do you need help with something?';
